module.exports = __webpack_public_path__ + "img/sbrmyy.83be8ab1.png";